// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sen-styles-wrapper-VP4mI8H1{display:flex;flex-direction:column;width:486px}.sen-styles-body-z_yxZ6rf{flex-grow:1;flex-shrink:1;padding:24px}`, "",{"version":3,"sources":["webpack://./src/components/MultiPointInstallation/Creation/styles.scss"],"names":[],"mappings":"AAAA,6BACE,YAAA,CACA,qBAAA,CACA,WAAA,CAGF,0BACE,WAAA,CACA,aAAA,CACA,YAAA","sourcesContent":[".wrapper {\n  display: flex;\n  flex-direction: column;\n  width: 486px;\n}\n\n.body {\n  flex-grow: 1;\n  flex-shrink: 1;\n  padding: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `sen-styles-wrapper-VP4mI8H1`,
	"body": `sen-styles-body-z_yxZ6rf`
};
export default ___CSS_LOADER_EXPORT___;
